import {
  Camera,
  OrthographicCamera,
  Scene,
  Sprite,
  SpriteMaterial,
  TextureLoader,
  Vector3,
  WebGLRenderer,
  LinearFilter,
} from "three";
import { Matrix4 } from "three/src/Three";
import pin from "../../../images/icons/pin.png";
import { Quick3DPerspectiveCamera } from "../camera/quick3d-perspective-camera";
import { Viewer } from "../viewer";

export class AutoAttenuablePin extends Sprite {
  private _viewer: Viewer;
  private _id: string;
  private _position: Vector3;
  // private _pinSprite: Sprite;
  // private _material: SpriteMaterial;

  public getPosition(): Vector3 {
    return this._position;
  }

  constructor(id: string, viewer: Viewer) {
    super();
    this._id = id;
    this._position = new Vector3();
    this._viewer = viewer;

    // mark
    this.material = new SpriteMaterial({
      map: new TextureLoader().load(pin, () => { viewer.updateRenderer(); }),
      sizeAttenuation: false,
      depthTest: false,
      // color: 0xFF0000,
    });
    this.material.map.minFilter = LinearFilter;
    this.geometry.computeBoundingBox();

    this.onBeforeRender = function (
      _ifcRenderer: WebGLRenderer,
      _nonClippingScene: Scene,
      camera: Camera
    ): void {
      let scale = 1;
      const windowScale = Math.sqrt(1280 * 720 / (window.screen.width * window.screen.height));
      if (camera instanceof OrthographicCamera) {
        scale = ((camera.right - camera.left) / camera.zoom) * 0.03 * windowScale;
      }
      if (camera instanceof Quick3DPerspectiveCamera) {
        scale = 0.07 * windowScale;
      }

      this.scale.set(scale, scale, scale);
      const rotationMatrix = new Matrix4().extractRotation(camera.matrixWorld)
      const upVector = new Vector3(0, 1, 0).applyMatrix4(rotationMatrix)
      if (camera instanceof OrthographicCamera) {
        this.position.copy(new Vector3().addVectors(this._position, upVector.multiplyScalar(scale * 0.45)));
      } else {
        const distance = (this.position.distanceTo(camera.position))
        this.position.copy(new Vector3().addVectors(this._position, upVector.multiplyScalar(distance * 0.03 * windowScale)));
      }
      this.updateMatrixWorld();
    };
  }

  public getId(): string {
    return this._id;
  }

  public setPosition(position: Vector3, offset: Vector3 = new Vector3()): void {
    this.position.set(
      position.x - offset.x,
      position.y - offset.y,
      position.z - offset.z
    );
    this._position.set(
      position.x - offset.x,
      position.y - offset.y,
      position.z - offset.z
    );
  }
}
